import { Color } from 'models';
import { StyledBox, StyledLogo, Spinner } from './Loader.styles';

interface LoaderProps {
  color?: Color;
  className?: string;
}

function Loader({ color = 'dark', className }: LoaderProps) {
  return (
    <StyledBox aria-label="loading" className={className}>
      <StyledLogo />
      <Spinner size={70} type={color} />
    </StyledBox>
  );
}

export default Loader;
